var map = {
	"./avatar-placeholder.png": "72c1",
	"./btn-banner-buy-coins.svg": "5e90",
	"./btn-banner-givegift.svg": "8259",
	"./btn-banner-promote.svg": "69f5",
	"./btn-banner-start-room.svg": "a010",
	"./btn-banner-upgrade.svg": "ed58",
	"./btn-header-back.svg": "b5ce",
	"./btn-header-reload.svg": "a4f3",
	"./btn-more-rooms.svg": "b9c9",
	"./btn-room-actions.svg": "e03b",
	"./icon-adult-web.svg": "102a",
	"./icon-adult.svg": "8493",
	"./icon-cam.svg": "bc17",
	"./icon-discover.svg": "9ae2",
	"./icon-filter-check.svg": "f72a",
	"./icon-home.svg": "4e47",
	"./icon-lock.svg": "d579",
	"./icon-room-promote.svg": "14ad",
	"./icon-search.svg": "e269",
	"./icon-users.svg": "7cb3",
	"./placeholders/cloud.png": "6e56",
	"./placeholders/ghost.png": "d074",
	"./placeholders/handshake.png": "63a5",
	"./placeholders/m_eyes.png": "380c",
	"./search-empty.svg": "0c01",
	"./subscription/badge-diamond.svg": "b50d",
	"./subscription/badge-gold.svg": "2714",
	"./subscription/badge-platinum.svg": "13e0",
	"./subscription/badge-plus.svg": "e633",
	"./subscription/badge-purple.svg": "fa06",
	"./subscription/badge-vip.svg": "7336"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a812";